export const VSS_HEADER_TYPE = {
  SUPPLIER_HEADER: 0,
  RENXIAO_HEADER: 1,
};

/**
 * VSS账户类型：目前有2种账户类型，0: 商品供应商账户，1: 劳动力供应商账户。 一个账号可以同时拥有 2 个账户类型。
 */
export const VSS_ACCOUNT_TYPE = [
  {
    label: "商品供应协同平台",
    code: 0,
    to: "/partner/index.html",
  },
  {
    label: "劳动力协同平台",
    code: 1,
    to: "/partner/renxiao/index.html",
  },
];

export const env = {
  dev: "development",
  test: "test",
  stage: "staging",
  Prod: "production",
};
